<div class="options">
	<div class="pe-search-results">
		<ng-container *ngIf="isGroupedDropdown; else simpleDropdown">
			<ng-container *ngFor="let group of filteredItems | keyvalue: noSort">
				<ng-container *ngIf="group.value.length">
					<ng-container *ngTemplateOutlet="dropdownItems; context: { title: group.key, items: group.value, groupedItems: true }"></ng-container>
				</ng-container>
			</ng-container>
		</ng-container>
	</div>
	<section *ngIf="browseButtonInformation" class="browse-button">
		<div class="item" (click)="itemSelected(browseButtonInformation)">
			<span>
				<icon class="browse-icon padding-right-5" type="search"></icon>
				<strong>{{ browseButtonInformation.description }}</strong>
			</span>
		</div>
	</section>
</div>

<ng-template #simpleDropdown>
	<ng-container *ngTemplateOutlet="dropdownItems; context: { title: title, items: filteredItems, groupedItems: false }"></ng-container>
</ng-template>

<ng-template #dropdownItems let-title="title" let-items="items" let-groupHeaders="groupedItems">
	<div class="item title text-14-bold" [ngClass]="{ 'group-header': groupHeaders }" *ngIf="title">{{ title }}</div>
	<ng-container *ngFor="let item of items">
		<div class="item" (click)="itemSelected(item)" data-cy="dropdown-option-item">
			<span>{{ item.description }}</span>
		</div>
	</ng-container>
</ng-template>
